// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dropdown-wrap.active {
    padding: 5px;
    background: #fff;
}

.dropdown-wrap.active .dropdown-list-wrap {
    padding: 5px;
    background: #fff;
    width: max-content;
    position: static;
}

.interval-dropdown-label {
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
}

    .interval-dropdown-label .icon-arrow {
        margin-left: 15px;
    }

.dropdown-list-wrap li {
    padding: 3px 0;
    cursor: pointer;
}

.dropdown-inner {
    font-size: 12px;
}
`, "",{"version":3,"sources":["webpack://./src/controls/chartcolumn/intervals/intervals.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;AACnB;;IAEI;QACI,iBAAiB;IACrB;;AAEJ;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB","sourcesContent":[".dropdown-wrap.active {\r\n    padding: 5px;\r\n    background: #fff;\r\n}\r\n\r\n.dropdown-wrap.active .dropdown-list-wrap {\r\n    padding: 5px;\r\n    background: #fff;\r\n    width: max-content;\r\n    position: static;\r\n}\r\n\r\n.interval-dropdown-label {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    cursor: pointer;\r\n}\r\n\r\n    .interval-dropdown-label .icon-arrow {\r\n        margin-left: 15px;\r\n    }\r\n\r\n.dropdown-list-wrap li {\r\n    padding: 3px 0;\r\n    cursor: pointer;\r\n}\r\n\r\n.dropdown-inner {\r\n    font-size: 12px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
